const delimiters = {
	default: ".",
	"fr-FR": ",",
};

const niceNum = (n, delimiter) => {
	const raw = String(n ?? "");
	const hasDecimal = raw.includes(".") || raw.includes(",");
	const locale = delimiter === "," ? "fr-FR" : "en-US";
	const value = Number(raw.replace(",", "."));
	if (!Number.isFinite(value)) return raw;
	const formatter = new Intl.NumberFormat(locale, {
		useGrouping: true,
		minimumFractionDigits: hasDecimal ? 2 : 0,
		maximumFractionDigits: hasDecimal ? 2 : 0,
	});
	return formatter.format(value);
};

// const niceNum = (n, delimiter) => {
// 	var num = n + "";
// 	num = num.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
// 	var parts = num.split(".");
// 	if (parts.length == 2) {
// 		if (parts[1].length == 1) {
// 			parts[1] += "0";
// 			num = parts.join(delimiter);
// 		}
// 		if (parts[1].length == 2) {
// 			num = parts.join(delimiter);
// 		}
// 	}
// 	return num;
// };

export default (price, locale, toFixed = 0) => {
	var delimiter = delimiters[locale] || delimiters.default;
	var nicePrice = niceNum((parseInt(price) / 100).toFixed(toFixed), delimiter);
	if (
		locale == "fr-FR" ||
		locale == "fr_FR" ||
		locale == "fr-FR-CSE" ||
		locale == "fr_FR_CSE"
	) {
		if (price < 0) {
			return "-" + nicePrice + "" + "€";
		} else {
			return nicePrice + "" + "€";
		}
	}
	if (locale == "fr-CH" || locale == "fr_CH") {
		if (price < 0) {
			return "-" + nicePrice + "" + "€";
		} else {
			return nicePrice + "" + "€";
		}
	}
	if (locale == "fr-BE" || locale == "fr_BE") {
		if (price < 0) {
			return "-" + nicePrice + "" + "€";
		} else {
			return nicePrice + "" + "€";
		}
	}
	if (locale == "nl-BE" || locale == "nl_BE") {
		if (price < 0) {
			return "-" + nicePrice + "" + "€";
		} else {
			return nicePrice + "" + "€";
		}
	}
	if (locale == "en-US" || locale == "en_US") {
		if (price < 0) {
			return "£" + nicePrice;
		} else {
			return "£" + "" + nicePrice;
		}
	}
	if (locale == "en-GB" || locale == "en_GB") {
		if (price < 0) {
			return "£" + nicePrice;
		} else {
			return "£" + "" + nicePrice;
		}
	}
	if (locale == "nl-NL" || locale == "nl_NL") {
		if (price < 0) {
			return "€" + nicePrice;
		} else {
			return "€" + nicePrice;
		}
	}
	return null;
};
